import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; Copyright <a href="https://forum.flyprat.no/misc/contact" target="_blank" rel="noopener noreferrer">Foreningen Flyprat</a>. We do not use cookies to track users.</p>
        <p>The usage of this site is governed by Norwegian law under the exclusive jurisdiction of Oslo district court.</p>
      </div>
    </footer>
  );
};

export default Footer;